import { useEffect } from "react";
import "@/App.css";
import { ReactLenis, useLenis } from "lenis/react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Manifesto from "@/components/site/Manifesto";
import About from "@/components/site/About";
import Workshops from "@/components/site/Workshops";
import ExperienceStatement from "@/components/site/ExperienceStatement";
import Marquee from "@/components/site/Marquee";
import Research from "@/components/site/Research";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import AboutPage from "@/components/site/AboutPage";
import { Toaster } from "@/components/ui/sonner";

function Home() {
  return (
    <>
      <Hero />
      <Manifesto />
      <About />
      <Workshops />
      <ExperienceStatement />
      <Marquee />
      <Research />
      <Testimonials />
      <Contact />
    </>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, lenis]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
        <ScrollToTop />
        <div className="App bg-ink text-sand font-body antialiased overflow-x-hidden" data-testid="site-root">
          <Nav />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<AboutPage />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="bottom-right" theme="dark" />
        </div>
      </ReactLenis>
    </BrowserRouter>
  );
}

export default App;
